import React from "react";

import * as styles from "./FeatureListing.module.scss";

const FeatureListing = ({ icon, title, children }) => {
    return (
        <div className={styles.feature}>
            <div className={styles.featureIcon}>{icon}</div>
            <span className={styles.featureTitle}>{title}</span>
            <span>{children}</span>
        </div>
    );
};

export default FeatureListing;
